import {IOnlineCondolenceSummary} from "../../types/resources/OnlineCondolenceSummary";
import OnlineCondolenceUtils from "../../utils/OnlineCondolenceUtils";
import {useTranslation} from "react-i18next";
import Title from './Title';
import LifeDates from './LifeDates';
import Stats from './Stats';
import Panel from '../Panel';
import ImageBlock from '../ImageBlock';
import {ImageSize} from '../../enums/ImageSize';
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import ConditionalLink from '../ConditionalLink';
import styled from 'styled-components';

const Right = styled.div`
    flex-wrap: wrap;
`

const CallToActionWrapper= styled.div`
    @media (max-width: 768px) {
        && {
            justify-content: flex-start;
        }
    }
`

const CallToAction = styled.div`
    @media (max-width: 768px) {
        && {
            font-size: smaller;
            margin-left: 0;
        }
    }
`

type TProps = {
    summary: IOnlineCondolenceSummary;
}

const OnlineCondolenceListItem = ({summary}: TProps) => {
    const {t} = useTranslation();
    const { publicUrl } = useSettingsContext();

    const fullName = OnlineCondolenceUtils.getFullName(summary);

    return (
        <ConditionalLink to={summary.pageUrl ? `/${summary.pageUrl}` : null}>
            <Panel>
                <div className="cr-mr-xl">
                    <ImageBlock
                        src={summary.imageFileUrl ?? `${publicUrl}/placeholder-condolence.jpg`}
                        placeholderSrc={`${publicUrl}/placeholder-condolence.jpg`}
                        alt={fullName}
                        size={ImageSize.Small}
                    />
                </div>
                <Right className={'cr-flex cr-gap cr-w-100'}>
                    <div className="cr-flex cr-flex-1 cr-flex-col cr-gap cr-justify-end cr-w-100">
                        <Title fullName={fullName}/>
                        <LifeDates dateOfBirth={summary.dateOfBirth} dateOfDeath={summary.dateOfDeath}/>
                        <div className="cr-mt">
                            <Stats
                                numberOfCandles={summary.numberOfCandles}
                                numberOfPosts={summary.numberOfPosts}
                                numberOfLikes={summary.numberOfLikes}
                            />
                        </div>
                    </div>
                    <CallToActionWrapper className="cr-flex cr-flex-1 cr-center cr-w-100">
                        <CallToAction className="cr-pill cr-ml-auto cr-mr-xl cr-text-secondary cr-border-secondary cr-upper">
                            {t('express-condolences')}
                        </CallToAction>
                    </CallToActionWrapper>
                </Right>
            </Panel>
        </ConditionalLink>
    )
}

export default OnlineCondolenceListItem;
